import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from './Constants';
import RequestHelper from './RequestHelper';
import { EVENT_TYPES } from '../lib/analytics/constants';
import Logger from '../lib/analytics/logger';
import { fetchGameRooms } from '../state/query/games/utils';
export default {
  /** @typedef {import('./Constants').InitRewardsResponse} InitRewardsResponse */

  /** @typedef {import('./Constants').GetPlayerOffersHistoryResponse} GetPlayerOffersHistoryResponse */

  /** @typedef {import('./Constants').GetRewardDetailResponse} GetRewardDetailResponse */

  /**
   * Initialize the Reward Center
   * @returns {InitRewardsResponse}
   */
  initializeRewardCenter: function () {
    var _initializeRewardCenter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var initRewardsResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.INIT_REWARDS
              }, true);

            case 3:
              initRewardsResponse = _context.sent;

              if (!(initRewardsResponse.success === false)) {
                _context.next = 6;
                break;
              }

              throw Error("[Init-Rewards-response] ".concat(initRewardsResponse.error));

            case 6:
              return _context.abrupt("return", initRewardsResponse);

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              throw _context.t0;

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    function initializeRewardCenter() {
      return _initializeRewardCenter.apply(this, arguments);
    }

    return initializeRewardCenter;
  }(),
  getRewardDetail: function () {
    var _getRewardDetail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(offerId) {
      var getRewardDetailResponse;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return RequestHelper.apiPost({
                endpoint: "".concat(Endpoints.GET_REWARD_DETAIL).concat(offerId)
              }, true);

            case 3:
              getRewardDetailResponse = _context2.sent;

              if (!(getRewardDetailResponse.success === false)) {
                _context2.next = 6;
                break;
              }

              throw Error("[Get-Reward_Detail-response] ".concat(getRewardDetailResponse.error));

            case 6:
              return _context2.abrupt("return", getRewardDetailResponse);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              throw _context2.t0;

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));

    function getRewardDetail(_x) {
      return _getRewardDetail.apply(this, arguments);
    }

    return getRewardDetail;
  }(),

  /**
   * Get Offer History
   * @returns {RewardCenterOfferHistory}
   */
  getOfferHistory: function () {
    var _getOfferHistory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var offerHistoryResponse, eventPayload;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return RequestHelper.apiGet({
                endpoint: Endpoints.GET_OFFER_HISTORY
              }, true);

            case 3:
              offerHistoryResponse = _context3.sent;

              if (!(offerHistoryResponse.success === false)) {
                _context3.next = 8;
                break;
              }

              eventPayload = {
                description: "Failed to load history.",
                code: 20
              };
              Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              throw Error("[Get-Offer-History-response] ".concat(offerHistoryResponse.err));

            case 8:
              return _context3.abrupt("return", Object.values(offerHistoryResponse));

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](0);
              throw _context3.t0;

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 11]]);
    }));

    function getOfferHistory() {
      return _getOfferHistory.apply(this, arguments);
    }

    return getOfferHistory;
  }(),
  purchaseOffer: function () {
    var _purchaseOffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(offerId, propertyId) {
      var purchaseOfferResponse, eventPayload;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.PURCHASE_OFFER,
                body: {
                  rid: offerId,
                  propertyId: propertyId
                }
              }, true);

            case 3:
              purchaseOfferResponse = _context4.sent;

              if (!purchaseOfferResponse.success) {
                eventPayload = {
                  description: "Can't redeem offer - ".concat(offerId, ", reason : ").concat(purchaseOfferResponse.error),
                  code: purchaseOfferResponse.error_code
                };
                Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              }

              fetchGameRooms(true);
              return _context4.abrupt("return", purchaseOfferResponse);

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              throw _context4.t0;

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 9]]);
    }));

    function purchaseOffer(_x2, _x3) {
      return _purchaseOffer.apply(this, arguments);
    }

    return purchaseOffer;
  }(),
  getPlayerOfferDetails: function () {
    var _getPlayerOfferDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(purchaseId) {
      var playerOfferDetailsResponse;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return RequestHelper.apiPost({
                endpoint: "".concat(Endpoints.GET_PLAYER_OFFER_DETAILS).concat(purchaseId)
              }, true);

            case 3:
              playerOfferDetailsResponse = _context5.sent;
              return _context5.abrupt("return", playerOfferDetailsResponse);

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](0);
              throw _context5.t0;

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 7]]);
    }));

    function getPlayerOfferDetails(_x4) {
      return _getPlayerOfferDetails.apply(this, arguments);
    }

    return getPlayerOfferDetails;
  }(),
  sendOfferEmail: function () {
    var _sendOfferEmail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(purchaseId) {
      var sendOfferEmailResponse, eventPayload;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.SEND_OFFER_EMAIL,
                body: {
                  rpid: purchaseId
                }
              }, true);

            case 3:
              sendOfferEmailResponse = _context6.sent;

              if (!sendOfferEmailResponse) {
                eventPayload = {
                  description: "Failed to email receipt for ".concat(purchaseId),
                  code: 21
                };
                Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              }

              return _context6.abrupt("return", sendOfferEmailResponse);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);
              throw _context6.t0;

            case 11:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 8]]);
    }));

    function sendOfferEmail(_x5) {
      return _sendOfferEmail.apply(this, arguments);
    }

    return sendOfferEmail;
  }()
};